export default "__VITE_ASSET__M0D54bY7__"